<template>
  <div id="app">
    <HomeHeader :isgzh="true"></HomeHeader>
    <div class="body_bg gzhbody_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
          <el-col
            :xs="24"
            :sm="24"
            :md="19"
            :lg="19"
            :xl="19"
            class="rightfloat"
          >
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">期刊动态</div>
                  <div class="clearfix"></div>
                </div>
                <listContent
                  :params="{ ColumnId: 2 }"
                  :isgzh="true"
                ></listContent>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import listContent from '../components/listContent'
import HomeHeader from '@/components/MasterTop'
export default {
  data() {
    return {
      keywords: '',
      activeName: 'first',
    }
  },
  components: {
    listContent,
    HomeHeader,
  },
  mounted() {
    document.title = '期刊动态'
  },
  methods: {},
}
</script>

<style scoped></style>
